<template>
   <div class="col-12">
      <div class="w-100 my-5">
         <table class="mx-auto">
            <tr>
               <td>
                  <img class="mx-auto" src="../assets/images/error_500.svg" />
               </td>
               <td class="align-middle align-items-start" style="max-width: 409px">
                  <div class="error-view-code">500</div>
                  <div class="error-view-title mb-3">Error interno del servidor</div>
                  <div class="error-view-subtitle">¡Lo sentimos!</div>
                  <div class="error-view-text">
                     Ocurrió un error y tu solicitud no ha<br />
                     podido ser procesada.<br />
                     Por favor, inténtalo de nuevo.
                  </div>
                  <button id="backButton" type="button" class="btn btn-primary mx-2 px-3" @click="volver">Volver</button>
               </td>
            </tr>
         </table>
      </div>
   </div>
</template>

<script setup>
import { useRouter } from "vue-router";
const router = useRouter();
const volver = () => {
   router.push("/");
};
</script>
